const urlProtheus = 'https://ricambi193839.protheus.cloudtotvs.com.br:4050/rest/api/v1/impostos';
const usernameProtheus = 'integracao_shopify';
const passwordProtheus = 'g6NJ1ZF71pUKdDo';
var authHeaderProtheus = `Basic ${btoa(`${usernameProtheus}:${passwordProtheus}`)}`;

function getTax(cnpj, id, price) {
    var price = Number(price) / 100;

    const cnpjCustomer = cnpj;
    // const cnpjCustomer ='37287528000101';

    const data = {
        cgc: cnpjCustomer,
        produtos: [{ codProtheus: id, qtde: 1, preco: price }],
    };

    return fetch(urlProtheus, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: authHeaderProtheus,
        },
        body: JSON.stringify(data),
    })
        .then((response) => response.json())
        .then((result) => {

            if (result.impostos && result.impostos.length > 0) {                 
                    return result.impostos[0].impostos;
            }
            return null;
        })
        .catch((error) => {
            console.error('Erro:', error);
            return null;
        });
}
